import {
  EmailSettingsEditDto,
  EmailSettingsEditDtoTypeEnum,
  TenantEmailSettingsDto,
} from '@/api/generator';
import { omit } from 'lodash';

export function toEmailSettingsEditDto(
  emailSettings: TenantEmailSettingsDto,
): EmailSettingsEditDto {
  const base = omit(
    emailSettings,
    'settingsAreProven',
    'useDefaultFromAddress',
    'useHostDefaultEmailSettings',
  );
  return {
    ...base,
    // Coerce backend empty strings to undefined so AJV `required` fires (bug 42976).
    defaultFromAddress: base.defaultFromAddress || undefined,
    defaultFromDisplayName: base.defaultFromDisplayName || undefined,
    smtpHost: base.smtpHost || undefined,
    $type:
      EmailSettingsEditDtoTypeEnum.PtwPtw100AppZeroApplicationSharedConfigurationDtoEmailSettingsEditDtoPtwPtw100AppZeroApplicationShared,
  } as EmailSettingsEditDto;
}
